// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { User } from '../../types'
import { updateOffer } from '../../actions/admin'
import AdminOfferForm from './components/AdminOfferForm'

type Props = {
  user: User,
  updateOffer: Function
}

class AdminUserOffers extends Component {
  props: Props

  handleUpdate = (userId, offerId, data) => {
    this.props.updateOffer(userId, offerId, data)
  }

  render() {
    const offers = this.props.user.offers || []

    return (
      <div>
        {offers.map((offer) => (
          <AdminOfferForm
            offer={offer}
            key={offer.id}
            onUpdate={this.handleUpdate}
          />
        ))}
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.admin.user
  }),
  {
    updateOffer
  }
)(AdminUserOffers)



// WEBPACK FOOTER //
// ./src/views/AdminUserOffers/index.js